import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';

export class GaTrackingGA4GeneralEvent implements GATrackingEvent {

  constructor(private payload: {
    event: string,
    gtmCustom?: any;
    label: string,
  }) {
  }

  getEventType(): any {
    return this.payload.event;
  }

  getPayload(): GATrackingEventPayload {
    const { event, gtmCustom, label } = this.payload;
    return {
      event,
      gtmCustom,
      label
    };
  }
}
